<template>
    <div class="container">
        <div v-show="checkResumeFinalData">
            <ModelConfig secTitle="" :showLeftCol="showCarLook" :showRigthCol="showCarOptions" rigthColClass="resumePage">
                <template v-slot:carLook>
                    <Model :isMobile="isMobile" />
                </template>
                <template v-slot:carOptions>
                    <ConfigResume :isMobile="isMobile" @click="displayCarOptions" @display-finances="handleFinances"/>
                </template>
            </ModelConfig>
            <div class="container-wrapContent w66">
                <ConfigResumeHeader v-show="showCarLook && isMobile" @click="displayCarOptions"/>
                <FeaturedBlock :secTitle="dataBO.resumePage.resumeTitle" :content="dataBO.resumePage.resumeContent" :showCatalog="false"/>
                <ConfigDetails id="detailsConfig"/>
                <router-link to="/" v-show="isMobile" class="btn-secondary">Nova Configuração</router-link>
            </div>
            <p v-show="isMobile && dataBO.hasSimul" class="btn-primary-rightIcon" @click="handleFinances">
                Financiamento
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>
            </p>

            <div id="financiamento" class="financeCont" v-if="dataBO.hasSimul" v-show="showFinances || !isMobile">
                <DetailsViewNav :isMobile="isMobile" :showContent="true" dvnClass="financeNav" configView="Financiamento" :optsLenght="lenght"
                    @change-view="handleFinances"> <span>Financiamento</span> </DetailsViewNav>
                <FinanceSection :isMobile="isMobile"/>
            </div>

            <div class="container-wrapContent">
                <LegalMentions compClass="resumePage" />
            </div>
        </div>
        <LoadingView v-show="!checkResumeFinalData" loaderClass="resumeLoader"/>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex'
    import ModelConfig from '../components/TemplateParts/ModelConfig/ModelConfig.vue'
    import Model from '../components/TemplateParts/Model/Model.vue'
    import ConfigResume from '../components/TemplateParts/ConfigResume/ConfigResume.vue'
    import ConfigResumeHeader from '../components/TemplateParts/ConfigResume/ConfigResumeHeader.vue'
    import FeaturedBlock from '../components/TemplateParts/SimpleContent/FeaturedBlock.vue'
    import ConfigDetails from '../components/TemplateParts/SimpleContent/ConfigDetails.vue'
    import LegalMentions from '../components/TemplateParts/SimpleContent/LegalMentions.vue'
    import DetailsViewNav from '../components/TemplateParts/SimpleContent/DetailsViewNav.vue'
    import FinanceSection from '../components/TemplateParts/FinanceSection/FinanceSection.vue'
    import { windowResized, handleNavOnScroll } from '../mixins/windowEventListeners'
    import { metatags } from '../mixins/comonMetaTags'
    import LoadingView from './LoadingView.vue'
    import { handleDataLayer } from '../mixins/handleDataLayer'

    export default {
        name: 'Resume',
        components:{ ModelConfig, Model, ConfigResume, ConfigResumeHeader, FeaturedBlock, ConfigDetails, LegalMentions, DetailsViewNav, FinanceSection, LoadingView},
        mixins: [metatags, windowResized, handleNavOnScroll, handleDataLayer],
        data(){return{
            showCarLook: true,
            showCarOptions: false,
            showFinances: false,
            lenght: 7,
            seoData: {
                "title": "Configurador",
                'titleTemplate': 'Resumo',
                "author": "Hyundai Portugal",
                "og_description": "Com o Configurador Hyundai, pode escolher e personalizar o seu Hyundai de sonho. Selecione o seu modelo favorito e escolha todas as características de acordo com as suas preferências.",
                "og_title": "Configurador Hyundai - Hyundai Portugal",
                "og_locale": "pt_PT",
                "og_type": "article",
                "og_site_name": "Hyundai Portugal"
            },
        }},
        mounted(){
            this.setDataLayerEndCfg()
        },
        provide:{
            page: 'Resume',
        },
        computed:{
            ...mapState(['dataBO', 'resumeData']),
            ...mapGetters({
                getVersion: 'versionsData/getVersionById',
                getPrice: 'resumeData/getFullPrice',
            }),
            checkResumeFinalData(){
                // // w8 for simulator 1st call and then show resume content with simul data.
                // let bool = this.resumeData.hasFinances
                // return bool

                // dont w8 for sifa data, show the data from cfg api´s, then update...
                return true
            },
            getVersionData(){ //temp
                let obj = this.getVersion(this.resumeData.versionID)
                let rD = this.resumeData
                let capitalToFinance = this.getPrice - rD.incialEntry

                if(!obj) obj = rD

                let res = {
                    carType: 'Novo',
                    nrPayments: obj.nrPayments,
                    initialValue: rD.incialEntry,
                    taeg: obj.taeg,
                    rate: obj.rate,
                    capitalToFinance: capitalToFinance,
                    mtic: obj.mtic,
                    fee: obj.rent,
                    residualValue: obj.residualValue,
                }
                return res
            }
        },
        methods:{
            displayCarOptions(e){
                let body =  document.body.classList
                if(this.isMobile){
                    this.showCarLook = !this.showCarLook
                    this.showCarOptions = !this.showCarOptions;
                    (e) ? body.remove('isActive') : body.toggle('isActive')
                }
            },
            handleFinances(){
                this.showFinances = !this.showFinances
                document.body.classList.toggle('isActive');
            },
        },
    }
</script>
<style lang="scss" scoped>
    .container-wrapContent > .btn-secondary,
    .btn-primary-rightIcon
    { margin-top: 1.5rem;}

    @include respond-to(maxLarge){
        .financeCont{
            position: fixed;
            z-index: 111;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: $primaryCol;
        }
    }
</style>
